import { Component, input } from '@angular/core';

@Component({
  selector: 'app-online-payment-setup-step',
  template: `
    <div class="space-y-2">
      <div class="text-lg font-medium">
        <ng-content select="[title]"></ng-content>
      </div>
      <div class="flex items-end gap-12">
        <div class="grow">
          <ng-content select="[description]"></ng-content>
        </div>

        @if (loadingData()) {
          <i class="fas fa-loader fa-spin text-3xl text-gray-muted"></i>
        } @else if (completed() === true) {
          <i
            class="fas {{
              customIconWithColor()
                ? customIconWithColor()
                : 'fa-check-circle text-green-500'
            }} text-3xl"
          ></i>
        } @else if (completed() === false) {
          <i
            class="fas {{
              customIconWithColor()
                ? customIconWithColor()
                : 'fa-times-circle text-gray-muted'
            }} text-3xl"
          ></i>
        }
      </div>
    </div>
  `,
  imports: [],
})
export class OnlinePaymentSetupStepComponent {
  completed = input.required<boolean | null>();
  customIconWithColor = input<string>();
  loadingData = input<boolean>();
}
